import api from './api';

const departureDateService = {
    // Get all departure dates with pagination and filters
    getDepartureDates: async (params = {}) => {
        const response = await api.get('/departure-dates', { params });
        return response.data;
    },

    // Get departure date by ID
    getDepartureDate: async (id) => {
        const response = await api.get(`/departure-dates/${id}`);
        return response.data;
    },

    // Create new departure date
    createDepartureDate: async (data) => {
        const response = await api.post('/departure-dates', data);
        return response.data;
    },

    // Update departure date
    updateDepartureDate: async (id, data) => {
        const response = await api.put(`/departure-dates/${id}`, data);
        return response.data;
    },

    // Delete departure date
    deleteDepartureDate: async (id) => {
        const response = await api.delete(`/departure-dates/${id}`);
        return response.data;
    },

    // Toggle departure date status
    toggleStatus: async (id) => {
        const response = await api.put(
            `/departure-dates/${id}/toggle-status`
        );
        return response.data;
    },

    // Get departure dates by package ID
    getDepartureDatesByPackage: async (packageId, params = {}) => {
        const response = await api.get(
            `/packages/${packageId}/departure-dates`,
            { params }
        );
        return response.data;
    },
};

export default departureDateService;
